module.exports = __webpack_public_path__ + "img/illusThrones5.9245a624.jpg";